import React from 'react'

const Maintenance = () => {
  return (
    <svg viewBox='0 0 473 343' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_1854_18019)'>
        <path d='M91.4502 333.48H380.357' stroke='#263238' strokeMiterlimit='10' />
        <path
          d='M341.202 184.414V126.854H349.535V120.95H374.458V125.673H380.947V224.19H398.792V241.458H472'
          stroke='#263238'
          strokeMiterlimit='10'
        />
        <path
          d='M231.037 192.162V147.664H248.218V158.29H256.551V142.867H274.911V209.357H290.397V233.119H332.354V196.295H341.202V188.62'
          stroke='#263238'
          strokeMiterlimit='10'
        />
        <path
          d='M184.065 162.497V241.458H211.865V195.115H220.197V234.3H231.037V199.247'
          stroke='#263238'
          strokeMiterlimit='10'
        />
        <path d='M164.451 220.647V123.312H184.066V155.929' stroke='#263238' strokeMiterlimit='10' />
        <path
          d='M103.322 192.162V203.453H112.245V152.387H147.86V231.348H164.451V223.599'
          stroke='#263238'
          strokeMiterlimit='10'
        />
        <path d='M-1.5 241.458H77.8085V167.811H103.322V186.186' stroke='#263238' strokeMiterlimit='10' />
        <path
          d='M382.127 76.9686C382.127 76.9686 377.408 67.449 368.486 68.6297C359.563 69.8105 358.383 78.7397 356.024 79.33C353.664 79.9204 348.281 76.3782 344.742 78.1493C341.202 79.9204 338.843 84.0529 338.843 84.0529C338.843 84.0529 334.124 82.2818 330.51 84.0529C326.897 85.824 325.201 89.3662 325.201 89.3662H399.382C399.382 89.3662 398.792 79.8466 393.483 78.0755C388.1 76.3782 384.561 81.7653 382.127 76.9686Z'
          stroke='#263238'
          strokeMiterlimit='10'
        />
        <path
          d='M280.073 111.136C280.073 111.136 276.534 104.125 269.971 105.011C263.409 105.896 262.524 112.464 260.754 112.907C258.984 113.35 255.076 110.693 252.421 112.021C249.767 113.35 248.071 116.375 248.071 116.375C248.071 116.375 244.531 115.047 241.951 116.375C239.296 117.704 237.969 120.36 237.969 120.36H292.756C292.756 120.36 292.314 113.35 288.406 112.021C284.498 110.693 281.843 114.604 280.073 111.136Z'
          stroke='#263238'
          strokeMiterlimit='10'
        />
        <path
          d='M94.3998 85.8242C94.3998 85.8242 91.4503 79.9206 85.9199 80.6586C80.3895 81.3965 79.6521 86.9312 78.1774 87.3001C76.7026 87.6691 73.3844 85.4552 71.1722 86.5622C68.9601 87.6691 67.4853 90.2519 67.4853 90.2519C67.4853 90.2519 64.5358 89.145 62.3236 90.2519C60.1114 91.3589 59.0054 93.5727 59.0054 93.5727H105.092C105.092 93.5727 104.723 87.6691 101.405 86.5622C98.0867 85.4552 95.8746 88.776 94.3998 85.8242Z'
          stroke='#263238'
          strokeMiterlimit='10'
        />
        <path
          d='M359.047 52.3213L312.001 16.0879L394.22 52.6165'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M196.306 143.9V71.6553'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M206.629 143.9V71.6553'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M214.519 54.5352H187.679V67.8183H214.519V54.5352Z'
          fill='#2E3030'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M211.865 75.5669H190.407L187.679 67.8184H214.593L211.865 75.5669Z'
          fill='#2E3030'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M173.889 42.6542L312.001 16.0879L253.084 42.6542'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M303.964 53.9447L316.942 43.392L308.609 34.6103L313.845 26.2715'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 319.312H303.964V53.9448L312.001 16.0879L320.113 53.9448V319.312Z'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 98.001L304.111 114.015H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 83.3154L304.111 99.4028H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 68.6299L304.111 84.7172H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 53.9443L304.111 70.0317H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 115.269L304.111 131.282H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 132.463L304.111 148.55H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 149.73L304.111 165.818H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 166.999L304.111 183.086H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 184.268L304.111 200.281H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 201.535L304.111 217.549H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 218.729L304.111 234.817H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 235.997L304.111 252.084H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 253.266L304.111 269.353H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 270.533L304.111 286.547H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M320.113 287.728L304.111 303.815H319.006'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M340.538 316.655H283.539V325.584H340.538V316.655Z' fill='#2E3030' />
        <path
          d='M360.226 324.256H263.776V333.406H360.226V324.256Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M322.251 80.6582H301.899V98.4428H322.251V80.6582Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M325.717 105.97H298.36V113.202H325.717V105.97Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M325.864 105.97H298.286L301.899 98.6641H322.251L325.864 105.97Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M323.431 80.9536H301.826V60.9551H324.832C326.086 60.9551 327.118 62.062 326.97 63.3165L325.496 78.9611C325.496 80.1418 324.611 80.9536 323.431 80.9536Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M310.601 65.3094V76.969C310.601 77.4118 310.969 77.7808 311.412 77.8545L319.081 78.6663C321.145 78.8877 322.915 77.2642 322.915 75.1979V65.3094C322.915 64.7928 322.546 64.4238 322.03 64.4238H311.485C310.969 64.4238 310.601 64.7928 310.601 65.3094Z'
          fill='#2E3030'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M365.83 55.1255H149.04L158.183 43.4658H292.092L297.844 53.8709'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M158.183 43.4658V54.6827L168.949 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M169.317 43.4658V54.6827L180.157 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M180.526 43.4658V54.6827L191.292 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M191.734 43.4658V54.6827L202.5 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M202.942 43.4658V54.6827L213.708 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M214.15 43.4658V54.6827L224.916 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M225.285 43.4658V54.6827L236.125 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M236.493 43.4658V54.6827L247.259 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M247.702 43.4658V54.6827L258.467 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M258.91 43.4658V54.6827L269.675 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M270.118 43.4658V54.6827L280.884 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M281.326 43.4658V54.6827L292.092 43.9086'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M312.001 20.2201C314.282 20.2201 316.131 18.3699 316.131 16.0876C316.131 13.8053 314.282 11.9551 312.001 11.9551C309.721 11.9551 307.872 13.8053 307.872 16.0876C307.872 18.3699 309.721 20.2201 312.001 20.2201Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M394.22 52.6162H355.359V57.3391H394.22V52.6162Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M387.51 57.2656H362.144V61.9885H387.51V57.2656Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M376.08 61.9883H364.798V76.157H376.08V61.9883Z'
          fill='#949191'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M324.021 53.8706V41.0303H392.819V52.6161'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M355.359 52.6167V40.957'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M344.741 54.6091V40.957'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M333.828 54.6091V40.957'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M368.485 52.6167V40.957'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M381.537 52.6167V40.957'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M324.39 47.5244H392.303'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M211.57 52.542H191.218V62.7995H211.57V52.542Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M194.61 52.542H191.513L201.689 62.7257H204.859L194.61 52.542Z' fill='#2E3030' />
        <path d='M195.273 62.7255H198.37L191.218 55.5674V58.6668L195.273 62.7255Z' fill='#2E3030' />
        <path d='M201.098 52.542H198.001L208.177 62.7257H211.348L201.098 52.542Z' fill='#2E3030' />
        <path d='M207.588 52.542H204.417L211.57 59.6263V56.5269L207.588 52.542Z' fill='#2E3030' />
        <path
          d='M201.615 140.876C201.615 140.876 201.615 144.713 201.615 147.222'
          stroke='#2E3030'
          strokeWidth='6'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M206.473 143.976V129.881H196.223V143.976H206.473Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M206.482 132.241V130.027L196.306 137.112V139.252L206.482 132.241Z' fill='#2E3030' />
        <path d='M196.306 132.61V134.824L203.459 129.88H200.288L196.306 132.61Z' fill='#2E3030' />
        <path d='M206.482 136.669V134.529L196.306 141.614V143.754L206.482 136.669Z' fill='#2E3030' />
        <path d='M206.482 141.17V139.03L199.403 143.901H202.5L206.482 141.17Z' fill='#2E3030' />
        <path
          d='M201.173 80.0678C199.993 80.0678 199.034 79.1085 199.034 77.9278V74.5332H203.237V77.9278C203.237 79.1823 202.279 80.0678 201.173 80.0678Z'
          fill='#EBD0D0'
          stroke='#2E3030'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <mask
          id='mask0_1854_18019'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='155'
          y='153'
          width='108'
          height='108'
        >
          <circle cx='209' cy='207' r='54' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_1854_18019)'>
          <circle cx='208' cy='207' r='59' fill='#E21B1B' />
          <path
            d='M190.5 235L226 266L247.5 253.5L269 224L265.5 219L238 188.5L225 185L214.5 174.5L176.5 215L186.5 224L190.5 235Z'
            fill='#C40606'
          />
        </g>
        <g clip-path='url(#clip1_1854_18019)'>
          <path
            d='M213.5 176H204V186L195.5 188.5L189 183.5L182 188.5L189 196.5L186.5 204H177.5V213.5H187.5L190 219L184 228L190 233L198 228L204 231.5V240H213.5V231.5L220 228L227.5 235.5L235 228L227.5 221L231.5 213.5H241V204H231.5L229.5 196.5L237 188.5L229.5 182L222 188.5L213.5 185V176Z'
            fill='white'
          />
          <path
            d='M209 194.846C212.451 194.846 215.583 196.265 217.858 198.548L217.871 198.561C220.146 200.857 221.539 204.017 221.539 207.5C221.539 210.983 220.133 214.143 217.871 216.439L217.858 216.452C215.583 218.748 212.451 220.154 209 220.154C205.549 220.154 202.417 218.735 200.142 216.452L200.129 216.439C197.854 214.143 196.461 210.983 196.461 207.5C196.461 204.017 197.867 200.857 200.129 198.561L200.142 198.548C202.417 196.252 205.549 194.846 209 194.846ZM230.755 211.847H239.421V205.423H231.317C230.525 205.423 229.847 204.894 229.617 204.172C229.208 202.882 228.786 201.657 228.352 200.47C227.917 199.283 227.444 198.096 226.933 196.91C226.626 196.213 226.805 195.426 227.304 194.923L233.708 188.46L229.195 183.907L223.035 190.124C222.421 190.744 221.475 190.821 220.772 190.357C219.609 189.66 218.395 189.041 217.155 188.499C215.877 187.944 214.56 187.48 213.192 187.132C212.387 186.925 211.85 186.19 211.85 185.39V177.625H205.485V185.558C205.485 186.409 204.897 187.132 204.105 187.312C202.762 187.699 201.471 188.202 200.244 188.809C198.992 189.428 197.777 190.163 196.64 191.027C195.886 191.595 194.812 191.466 194.211 190.756L188.728 185.042L184.241 189.57L190.351 195.723C190.875 196.252 191.016 197.039 190.747 197.683C190.326 198.728 189.929 199.773 189.571 200.831C189.201 201.915 188.881 202.998 188.6 204.082C188.383 204.92 187.629 205.462 186.811 205.423H178.592V211.847H187.36C188.14 211.847 188.805 212.35 189.047 213.047C189.456 214.105 189.878 215.085 190.3 216.027C190.773 217.071 191.233 218.039 191.693 218.955C192.051 219.664 191.898 220.503 191.361 221.044L185.609 226.862L190.108 231.403L195.873 225.585C196.435 225.018 197.292 224.901 197.969 225.263C199.426 225.933 201.011 226.617 202.647 227.327L204.411 228.1C205.089 228.397 205.498 229.055 205.498 229.765V237.388H211.863V229.868C211.863 229.068 212.387 228.384 213.103 228.152L216.35 226.888C217.347 226.488 218.344 226.062 219.353 225.611C220.044 225.301 220.836 225.469 221.347 225.985L227.751 232.435L232.263 227.894L226.23 221.806C225.642 221.212 225.553 220.309 225.949 219.613C226.511 218.581 227.048 217.51 227.585 216.401C228.122 215.291 228.62 214.143 229.119 212.969C229.4 212.26 230.065 211.86 230.755 211.847ZM241.211 215.459H231.931C231.56 216.31 231.189 217.136 230.793 217.949C230.435 218.697 230.065 219.432 229.681 220.18L236.047 226.604C236.737 227.314 236.737 228.449 236.034 229.145L229.004 236.24C228.301 236.95 227.176 236.95 226.473 236.24L219.673 229.378C218.254 229.971 216.861 230.539 215.442 231.093V239.181C215.442 240.174 214.637 240.987 213.653 240.987H203.708C202.724 240.987 201.919 240.174 201.919 239.181V230.938L201.229 230.642C199.989 230.1 198.787 229.584 197.522 229.016L191.361 235.234C190.658 235.943 189.533 235.943 188.83 235.234L181.8 228.139C181.097 227.43 181.097 226.295 181.8 225.585L187.91 219.419C187.59 218.774 187.296 218.129 187.015 217.51C186.708 216.826 186.402 216.13 186.12 215.459H176.789C175.805 215.459 175 214.646 175 213.653V203.617C175.013 202.624 175.805 201.824 176.789 201.824H185.507C185.724 201.089 185.941 200.367 186.184 199.67C186.44 198.909 186.708 198.161 187.002 197.413L180.458 190.821C179.755 190.111 179.755 188.976 180.458 188.267L187.514 181.159C188.217 180.463 189.354 180.488 190.032 181.198L195.796 187.209C196.729 186.59 197.701 186.035 198.685 185.545C199.733 185.029 200.807 184.59 201.919 184.204V175.806C201.919 174.813 202.724 174 203.708 174H213.653C214.637 174 215.442 174.813 215.442 175.806V184.023C216.516 184.358 217.551 184.745 218.561 185.184C219.558 185.61 220.529 186.087 221.462 186.603L227.93 180.076C228.633 179.379 229.758 179.379 230.448 180.076L237.491 187.17C238.194 187.88 238.194 189.015 237.491 189.724L230.678 196.6C231.023 197.451 231.368 198.316 231.688 199.206C232.008 200.07 232.314 200.947 232.608 201.824H241.211C242.195 201.824 243 202.637 243 203.63V213.666C243 214.659 242.195 215.459 241.211 215.459ZM215.34 201.102C213.729 199.464 211.48 198.457 209 198.457C206.52 198.457 204.283 199.464 202.66 201.102L202.647 201.115C201.024 202.74 200.027 205.01 200.027 207.513C200.027 210.015 201.024 212.273 202.647 213.911L202.66 213.924C204.271 215.562 206.52 216.568 209 216.568C211.48 216.568 213.717 215.562 215.34 213.924L215.353 213.911C216.976 212.286 217.973 210.015 217.973 207.513C217.973 205.01 216.963 202.74 215.34 201.102Z'
            fill='white'
          />
          <circle cx='209' cy='208' r='15' stroke='#C40606' strokeWidth='2' />
        </g>
        <path
          d='M201.616 147.222C201.616 148.402 201.616 165.405 201.616 165.405C201.616 167.029 199.772 168.652 198.887 169.833C196.528 173.301 197.929 179.648 202.795 179.722C206.925 179.795 209 176 208 171.5'
          stroke='#2E3030'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <rect x='205' y='169' width='7' height='5' fill='#E21B1B' />
      </g>
      <defs>
        <clipPath id='clip0_1854_18019'>
          <rect width='473' height='343' fill='white' />
        </clipPath>
        <clipPath id='clip1_1854_18019'>
          <rect width='68' height='67' fill='white' transform='translate(175 174)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Maintenance
